import type { TranslationDict } from './ja'

export const tr: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'Nasıl oynanır',
  helpAria: 'Nasıl oynanır',
  settings: 'Ayarlar',
  settingsAria: 'Ayarlar',
  close: 'Kapat',
  closeAria: 'Kapat',
  player: 'Oyuncu',
  highscore: 'En yüksek skor',
  start: 'Oyunu başlat',
  staminaEmpty: 'Yeterli stamina yok',
  ranking: 'Bölge Savaşı',
  difficultyTitle: 'Zorluk seç',
  difficultyStart: 'Bu zorlukla başla',
  back: 'Geri',
  today: 'Bugün',
  weekly: 'Bu hafta',
  alltime: 'Genel',
  loading: 'Yükleniyor...',
  noScores: 'Henüz skor yok. İlk şampiyon sen ol!',
  loadFailed: 'Yüklenemedi',
  you: 'Sen',
  youConstant: 'SEN',
  language: 'Dil',
  languageNote: 'Japonca dahil 18 dili destekler.',
  bgm: 'Müzik',
  se: 'Ses efektleri',
  soundEnableAria: 'Sesi aç',
  soundDisableAria: 'Sesi kapat',
  adWatch: 'Reklamı sonuna kadar izle',
  adCancel: 'Şimdi değil',
  rankSuffix: '.',
  earnedPoints: '{score} puan kazandı',
  helpGoalTitle: '🎯 Amaç',
  helpGoalText: '9x9 tahtaya taşlarını yerleştir ve bağlı bölgelerini genişlet. En yüksek puanı alan kazanır.',
  helpWinTitle: '🏆 Kazanma Şartları',
  helpWinFive: 'Dikey, yatay veya çapraz olarak beşli bir sıra yaparak anında kazan.',
  helpWinScore: 'Tahta dolduğunda en yüksek puanı alan kazanır. Beraberlik yoktur.',
  helpScoreTitle: '💯 Puanlama',
  helpLineBonus: 'Sıra Bonusu: 3, 4 ve 5li sıralar yaparak puan kazan.',
  helpClusterBonus: 'Bölge Bonusu: Bağlı grupların büyüdükçe daha fazla puan al.',
  helpKomi: 'Komi: İkinci oyuncu %10 puan avantajı alır.',
  helpControlsTitle: '🖱️ Kontroller',
  helpControlsText: 'Sıran geldiğinde, taş koymak için boş bir hücreye dokun.',
  helpTipsTitle: '💡 İpuçları',
  helpTipHell: 'En zorlu mücadele için HELL modunu dene.',
  helpTipCluster: 'Sadece beşli yapmaya odaklanma. Büyük bağlı gruplar da puanını önemli ölçüde artırır.',
  resultWinFive: '🎉 Beşli yaptın! Kazandın!',
  resultWinScore: '🎉 Puanla kazandın! Kazandın!',
  resultLoseFive: '😿 CPU beşli yaptı!',
  resultLoseScore: '😿 Puanla kaybettin. Tekrar dene!',
  resultDraw: '🤝 Beraberlik',
  newHighscore: '🏆 Yeni en yüksek skor!',
  scoreNone: 'Skor yok',
  clusterBonus: 'Bölge bonusu',
  retry: 'Tekrar oyna',
  titleBack: 'Başlık',
  scoreHintPlaceStone: 'Taş koy',
  best: 'En iyi',
  clusterUnit: 'bölge',
  lineCount: '{len}li sıra x{count}',
  turnCount: 'Hamle {count} · {difficulty}',
  boardPlayerPiece: 'Senin taşın',
  boardCpuPiece: 'CPU taşı',
  boardPlayerAlt: 'Sen',
  boardCpuAlt: 'CPU',
  boardCellPosition: 'satır {row}, sütun {col}',
  boardPlaceable: 'koyulabilir',
  boardEmpty: 'boş hücre',
  boardFlower: 'çiçekli',
  firstPlayerAlt: 'İlk oyuncu',
  playerFirst: 'İlk sen başlıyorsun!',
  playerSecond: 'İkinci sen başlıyorsun (+%{bonus} komi)',
  cpuFirst: 'İlk CPU başlıyor!',
  finalePlayerWin: 'Kazandın!',
  finaleCpuWin: 'CPU kazandı!',
  finaleFive: 'Beşli sıra!',
  finaleTerritory: 'Bölge savaşı!',
  winnerAlt: 'Kazanan',
  loadingBoot: 'Başlatılıyor...',
  loadingConnect: 'Bağlanılıyor...',
  loadingProfile: 'Profil yükleniyor...',
  loadingAssets: 'Varlıklar yükleniyor...',
  loadingReady: 'Hazır',
  reauthRequiredTitle: 'Giriş gerekli',
  startupFailedTitle: 'Başlatma başarısız',
  reauthButton: 'Tekrar giriş yap',
  reloadButton: 'Yeniden yükle',
  lineReloginButton: 'LINE girişi',
  reauthReason: 'Giriş süreniz doldu. Lütfen tekrar giriş yapın.',
  errorReauth: 'Giriş süreniz doldu. Lütfen tekrar giriş yapın.',
  errorForbidden: 'Bu oyunu kullanma izniniz yok.',
  errorNotFound: 'Oyun verisi bulunamadı.',
  errorRateLimited: 'Ağ meşgul. Lütfen bekleyin ve tekrar deneyin.',
  errorServer: 'Sunucuya bağlanılamadı. Lütfen bekleyin ve yeniden yükleyin.',
  errorCommunication: 'Bir iletişim hatası oluştu. Lütfen yeniden yükleyin.',
  errorNetwork: 'Ağa bağlanılamadı. Bağlantınızı kontrol edin ve yeniden yükleyin.',
  errorStartup: 'Başlatma başarısız. Lütfen yeniden yükleyin.',
  settingsTabGeneral: 'Ayarlar',
  settingsTabAccount: 'Hesap',
  settingsTabInfo: 'Bilgi',
  account: 'Hesap',
  linked: 'Bağlı',
  guest: 'Misafir',
  loggedInWith: '{provider} ile giriş yapıldı',
  loggedIn: 'Giriş yapıldı',
  playingAsGuest: 'Şu anda misafir olarak oynuyorsunuz.',
  appleLoginBusy: 'Apple ile giriş yapılıyor...',
  appleLogin: 'Apple ile giriş yap',
  googleLoginBusy: 'Google ile giriş yapılıyor...',
  googleLogin: 'Google ile giriş yap',
  logoutBusy: 'Çıkış yapılıyor...',
  logout: 'Çıkış yap',
  logoutSuccess: 'Çıkış yapıldı',
  logoutFailed: 'Çıkış başarısız',
  appInfo: 'Uygulama bilgisi',
  appName: 'Uygulama adı',
  version: 'Versiyon',
  legalInfo: 'Yasal',
  terms: 'Kullanım Koşulları',
  privacy: 'Gizlilik Politikası',
  operator: 'İşletmeci',
  contact: 'İletişim',
  copyTap: 'Kopyalamak için dokun',
  idCopied: 'ID kopyalandı',
  copyFailed: 'Kopyalama başarısız',
  other: 'Diğer',
  reportAd: 'Uygunsuz reklamı bildir',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'Profili düzenle',
  displayName: 'Görünen ad',
  displayNamePlaceholder: 'Bir ad girin',
  chooseIcon: 'Simge seç',
  iconLoadFailed: 'Simgeler yüklenemedi.',
  saveFailed: 'Kaydetme başarısız. Lütfen tekrar deneyin.',
  noIcons: 'Kullanılabilir simge yok.',
  save: 'Kaydet',
  saving: 'Kaydediliyor...',
  staminaAria: 'Stamina {stamina} / {max}',
  nextRecovery: 'Sıradaki yenilenme {time} içinde',
  adPlaying: 'Reklam oynatılıyor...',
  recoverFullAd: 'Tam stamina yenilemek için reklam izle',
  dailyBonusAria: '+5 stamina için reklamı sonuna kadar izle',
  dailyBonusAd: '+5 stamina için reklam izle',
  legalLastUpdated: 'Son güncelleme: {date}',
  privacyTitle: 'Gizlilik Politikası',
  termsTitle: 'Kullanım Koşulları',
  adPlayingAria: 'Reklam oynatılıyor',
  adBadge: '▶ Reklam',
  adRemaining: '{seconds}sn kaldı',
  adDevHint: 'Geliştirme test reklamı. Canlı sürümde bir AdMob videosu oynatılacaktır.',
  adRewardRequirement: 'Bu ödülü almak için reklamı sonuna kadar izle.',
  adRewardStaminaDetail: 'Ödül: stamina en yüksek değere tamamlanır',
  adRewardDailyBonusDetail: 'Ödül: günlük bonus olarak +{amount} stamina',
  adRewardIncompleteNote: 'Bitmeden kapatırsan ödül verilmez.',
  adSkipAria: 'Reklamı geç',
  adSkip: 'Geç ✕',
  adSkipAfter: '{seconds}sn içinde geç',
  offlineMessage: 'Sunucuya bağlanılamıyor. Bazı özellikler kullanılamayabilir.',
  reconnecting: 'Yeniden bağlanılıyor...',
  reconnect: 'Yeniden bağlan',
  signInTitle: 'Giriş yap',
  signInBusy: 'Giriş yapılıyor...',
  signInCancelNote: 'Girişi iptal ederseniz misafir olarak devam edebilirsiniz (bazı özellikler kısıtlanır).',
  processing: 'İşleniyor...',
  recoverConfirmTitle: 'Veri üzerine yazmayı onayla',
  recoverConfirmMessage: 'Bu girişle ilişkili mevcut veriler var. Devam etmek, bu cihazdaki misafir verilerinin üzerine yazacaktır. Devam etmek istiyor musunuz?',
  recoverConfirmContinue: 'Geri Yükle',
  recoverConfirmCancel: 'İptal',
  unlinkConfirmTitle: 'Hesap bağını kaldır',
  unlinkConfirmMessage: 'Bu sağlayıcıyla olan bağı kaldırırsanız, cihaz misafir moduna dönecektir. Hub verileriniz, başka bir cihazda aynı sağlayıcıyla tekrar giriş yaparsanız kullanılabilir kalır.',
  unlinkConfirmContinue: 'Bağı Kaldır',
  unlinkConfirmCancel: 'İptal',
  deleteConfirmTitle: 'Hesap silmeyi onayla',
  deleteConfirmMessage: 'Hesabınızı silmek; en yüksek skorları, giriş verilerini, bağlı hesapları ve davetleri kaldıracaktır.\nBu işlem geri alınamaz. Gerçekten silmek istiyor musunuz?',
  deleteConfirmContinue: 'Hesabı sil',
  deleteConfirmCancel: 'İptal',
  adNekoTitle: 'Reklam Kedisi',
  matchmakingRemaining: '{seconds}sn kaldı',
  matchmakingTimeoutMessage: 'Zamanında bir rakip bulunamadı. Lütfen tekrar deneyin.',
  difficultyEasyName: 'Rahat',
  difficultyEasyDescription: 'Rakip biraz dalgın görünüyor',
  difficultyNormalName: 'Normal',
  difficultyNormalDescription: 'Rakip bazen hata yapıyor',
  difficultyHardName: 'Zor',
  difficultyHardDescription: 'Rakip tahtaya çok hakim',
  difficultyHellName: 'Aşırı',
  difficultyHellDescription: 'Rakip çok güçlü ve hamleleri önceden seziyor',
}
